import { render } from "./BestsellerProducts.vue?vue&type=template&id=09206683&scoped=true"
import script from "./BestsellerProducts.vue?vue&type=script&lang=js"
export * from "./BestsellerProducts.vue?vue&type=script&lang=js"

import "./BestsellerProducts.vue?vue&type=style&index=0&id=09206683&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09206683"]])

export default __exports__